import ModalVideoBox from "../elements/ModalVideoBox";
import { AboutServiceArr } from "../elements/JsonData";
import { Link } from "react-router-dom";
import Header from "../components/Header";

const AboutUs = () => {

  return (
    <div className="page-content bg-white">
    <Header />

      <ModalVideoBox />
      <section className="content-inner">
        <div className="container mt-5">
          <div className="section-head text-center">
            <h2 className="title">What We Do</h2>
          </div>
          <div className="row">
            {AboutServiceArr.map(({ icon, title }, ind) => (
              <div className="col-lg-3 col-sm-6 m-b30" key={ind}>
                <div className="icon-bx-wraper style-3">
                  <div className="icon-bx">
                    <div className="icon-cell">
                      <i className={icon}></i>
                    </div>
                  </div>
                  <div className="icon-content">
                    <h5 className="title">
                      <Link to="/">{title}</Link>
                    </h5>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
